import axios from 'axios';

const ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

export const sendContactForm = async (formData) => {
  try {
    const response = await axios.post('https://api.web3forms.com/submit', {
      access_key: ACCESS_KEY,
      ...formData,
    });

    return {
      success: response.data.success,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Web3Forms error:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};
